import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import React from "react";
import { useParams } from "react-router-dom";
import { KEY } from "../utils/ChartUtils";
import AflInfoCard from "./AflInfoCard";
import AflMovementProfile from "./AflMovementProfile";
import AflPitchHeatmap from "./AflPitchHeatmap";
import AflReleaseProfile from "./AflReleaseProfile";
import AflPitchSplits from "./AflPitchSplits";
import AflSprayChart from "./AflSprayChart";
import AflSwingChart from "./AflSwingChart";
import AflHitterGameLogs from "./AflHitterGameLogs";
import AflHitterStats from "./AflHitterStats";
import AflPitcherGameLogs from "./AflPitcherGameLogs";
import AflPitcherStats from "./AflPitcherStats";
import AflArsenalProfile from "./AflArsenalProfile";
import AflHitterPercentiles from "./AflHitterPercentiles";
import AflPitcherPercentiles from "./AflPitcherPercentiles";


function reducePitchData(data: any[]) {
  const resultMap = new Map();

  data.forEach((item: any) => {
    // Use pitch_type as the key since we want one entry per pitch type
    const key = item.pitch_type;

    if (!resultMap.has(key)) {
      // Initialize with both left and right percentages set to 0
      resultMap.set(key, {
        pitchName: item.pitch_name,
        pitchType: item.pitch_type,
        leftPercent: 0,
        rightPercent: 0
      });
    }

    // Update the appropriate percentage based on batter handedness
    const pitchData = resultMap.get(key);
    if (item.stand === 'L') {
      pitchData.leftPercent = -Math.abs(item.percentage); // Ensure negative for lefties
    } else {
      pitchData.rightPercent = Math.abs(item.percentage); // Ensure positive for righties
    }
  });

  return Array.from(resultMap.values());
}

export default function PlayerPage(props: any) {
  const [playerData, setPlayerData] = useState<any>({});
  const [playerInfo, setPlayerInfo] = useState<any>({});
  const { id, season } = useParams();
  // Optional route segment: /afl/player/:id keeps pointing at the newest season.
  const seasonPath = season ? "/" + season : "";

  const [pitchData, setPitchData] = useState<any[]>([]);
  const [pitches, setPitches] = useState<any[]>([]);
  const [armAngle, setArmAngle] = useState<Number>(0);
  const [splitData, setSplitData] = useState<any[]>([]);


  useEffect(() => {
    fetch(
      props.prod
        ? "https://oriolebird.pythonanywhere.com/afl/player/" + id + seasonPath
        : "/afl/player/" + id + seasonPath
    )
      .then((res) => res.json())
      .then((data1) => {
        console.log("D1: ", data1);
        setPlayerData(data1[0])
        fetch(
          props.prod
            ? `https://oriolebird.pythonanywhere.com/player-info/`
            : "/player-info/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              playerUrlProp: data1[0]["UPURL"],
            }),
          }
        )
          .then((res) => res.json())
          .then((data2) => {
            setPlayerInfo(data2);
            const height = data2.common.playerInfo.Height
            //console.log("d2: ", data2)
            if (data1[0].Position === "P")
              fetch(
                props.prod
                  ? "https://oriolebird.pythonanywhere.com/afl/pitches/" + id + "/" + height + seasonPath
                  : "/afl/pitches/" + id + "/" + height + seasonPath
              )
                .then((res) => res.json())
                .then((data3) => {
                  //console.log("D3: ", data3);
                  setPitchData(data3)
                  const p = Object.keys(data3.reduce((r: any, { pitch_type }: any) => { r[pitch_type] = ''; return r; }, {})).map((pitch: string) => KEY[pitch])
                  //console.log("Pitches: ", p.toString())
                  setPitches(p)
                  const spl = reducePitchData(data3)
                  //console.log("SPL", spl)
                  setSplitData(spl)
                  console.log(data3)
                  setArmAngle(data3[0].avg_arm_angle.toFixed(1))
                })
          })
      })

  }, [id, props.prod, seasonPath]);
  console.log("PD:", playerData);
  //console.log("pi:", playerInfo);
  //console.log(percentiles)
  return (
    <div>

      {playerData !== undefined && playerData !== null && (
        <div style={{ marginBottom: "10px" }}>
          <title>{playerData.batter_name !== undefined || playerData.pitcher_name !== undefined ? (playerData.pitcher_name ? playerData.pitcher_name +" - Prospect Savant" : playerData.batter_name + " - Prospect Savant") : "Prospect Savant"}</title>

          <Grid container justifyContent="center" spacing={2} maxWidth="100%">
            <Grid item maxWidth="90vw">
              <Paper
                sx={{
                  height: "100%",
                  maxWidth: "90vw",
                  width: 500,
                  border: "#293241 solid 2px",
                  backgroundColor: "#FFFFFF",
                  boxShadow:
                    "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
                }}
                square
                variant="outlined"
              >
                {playerInfo.common && <AflInfoCard playerDataProp={playerData} playerInfoProp={playerInfo} idProp={id} />}
              </Paper>
            </Grid>
            {playerData.Position === "P" && "common" in playerInfo && (
              <Grid item maxWidth="90vw">
                <AflPitcherPercentiles
                  isDesktop={props.isDesktop}
                  id={id}
                  prod={props.prod}
                  playerInfoProp={playerInfo}
                  playerDataProp={playerData}
                />
                <AflPitcherStats
                  isDesktop={props.isDesktop}
                  id={id}
                  prod={props.prod}
                  playerInfoProp={playerInfo}
                  playerDataProp={playerData}
                />
              </Grid>
            )}
            {playerData.Position === "P" && "common" in playerInfo && (
              <Grid item maxWidth="90vw">
                <AflMovementProfile
                  isDesktop={props.isDesktop}
                  id={id}
                  prod={props.prod}
                  height={playerInfo.common.playerInfo.Height}
                  playerDataProp={playerData}
                  playerInfoProp={playerInfo}
                  pitchData={pitchData}
                  pitches={pitches}
                />
                <AflArsenalProfile
                  isDesktop={props.isDesktop}
                  id={id}
                  prod={props.prod}
                  season={season}
                  playerDataProp={playerData}
                  playerInfoProp={playerInfo}
                />
              </Grid>
            )}
            {playerData.Position === "P" && "common" in playerInfo && pitchData.length !== 0 && (

              <AflPitchHeatmap
                isDesktop={props.isDesktop}
                id={id}
                prod={props.prod}
                playerDataProp={playerData}
                playerInfoProp={playerInfo}
                pitchData={pitchData}
                pitches={pitches}
              />
            )}
            {playerData.Position === "P" && "common" in playerInfo && pitchData.length !== 0 && (

              <AflPitchSplits
                isDesktop={props.isDesktop}
                id={id}
                playerDataProp={playerData}
                prod={props.prod}
                height={playerInfo.common.playerInfo.Height}
                playerInfoProp={playerInfo}
                splitData={splitData}
              />
            )}
            {playerData.Position === "P" && "common" in playerInfo && pitchData.length !== 0 && (

              <AflReleaseProfile
                isDesktop={props.isDesktop}
                id={id}
                prod={props.prod}
                playerDataProp={playerData}
                height={playerInfo.common.playerInfo.Height}
                playerInfoProp={playerInfo}
                pitchData={pitchData}
                pitches={pitches}
                armAngle={armAngle}
              />
            )}
            {playerData.Position === "P" && "common" in playerInfo && (
              <Grid item maxWidth="90vw">
                <AflPitcherGameLogs
                  isDesktop={props.isDesktop}
                  id={id}
                  prod={props.prod}
                  season={season}
                  playerInfoProp={playerInfo}
                  playerDataProp={playerData}
                />
              </Grid>
            )}
            {playerData.Position !== "P" && "common" in playerInfo && (
              <Grid item maxWidth="90vw">
                <AflHitterPercentiles
                  isDesktop={props.isDesktop}
                  id={id}
                  prod={props.prod}
                  playerInfoProp={playerInfo}
                  playerDataProp={playerData}
                />
                <AflHitterStats
                  isDesktop={props.isDesktop}
                  id={id}
                  prod={props.prod}
                  playerInfoProp={playerInfo}
                  playerDataProp={playerData}
                />
                
              </Grid>
              
            )}
            {playerData.Position !== "P" && "common" in playerInfo && (
              <Grid item maxWidth="90vw">
                <AflSprayChart
                  isDesktop={props.isDesktop}
                  id={id}
                  prod={props.prod}
                  season={season}
                  playerInfoProp={playerInfo}
                  playerDataProp={playerData}
                />
                <AflSwingChart
                  isDesktop={props.isDesktop}
                  id={id}
                  prod={props.prod}
                  season={season}
                  playerInfoProp={playerInfo}
                  playerDataProp={playerData}
                />
              </Grid>

            )}
            {playerData.Position !== "P" && "common" in playerInfo && (
              <Grid item maxWidth="90vw">
                <AflHitterGameLogs
                  isDesktop={props.isDesktop}
                  id={id}
                  prod={props.prod}
                  season={season}
                  playerInfoProp={playerInfo}
                  playerDataProp={playerData}
                />
              </Grid>
            )}
          </Grid>
        </div>
      )}
    </div>
  );
}
